export default {"src":"/_next/static/media/section-adornment1-m.d6f46c25.svg","height":40,"width":375,"blurWidth":0,"blurHeight":0};